// SMS Management Actions
export const FETCH_SMS_MANAGEMENT_REQUEST = 'FETCH_SMS_MANAGEMENT_REQUEST';
export const FETCH_SMS_MANAGEMENT_SUCCESS = 'FETCH_SMS_MANAGEMENT_SUCCESS';
export const FETCH_SMS_MANAGEMENT_FAILURE = 'FETCH_SMS_MANAGEMENT_FAILURE';

export const FETCH_SMS_MANAGEMENT_BY_ID_REQUEST = 'FETCH_SMS_MANAGEMENT_BY_ID_REQUEST';
export const FETCH_SMS_MANAGEMENT_BY_ID_SUCCESS = 'FETCH_SMS_MANAGEMENT_BY_ID_SUCCESS';
export const FETCH_SMS_MANAGEMENT_BY_ID_FAILURE = 'FETCH_SMS_MANAGEMENT_BY_ID_FAILURE';

export const CREATE_SMS_MANAGEMENT_REQUEST = 'CREATE_SMS_MANAGEMENT_REQUEST';
export const CREATE_SMS_MANAGEMENT_SUCCESS = 'CREATE_SMS_MANAGEMENT_SUCCESS';
export const CREATE_SMS_MANAGEMENT_FAILURE = 'CREATE_SMS_MANAGEMENT_FAILURE';

export const UPDATE_SMS_MANAGEMENT_REQUEST = 'UPDATE_SMS_MANAGEMENT_REQUEST';
export const UPDATE_SMS_MANAGEMENT_SUCCESS = 'UPDATE_SMS_MANAGEMENT_SUCCESS';
export const UPDATE_SMS_MANAGEMENT_FAILURE = 'UPDATE_SMS_MANAGEMENT_FAILURE';

export const DELETE_SMS_MANAGEMENT_REQUEST = 'DELETE_SMS_MANAGEMENT_REQUEST';
export const DELETE_SMS_MANAGEMENT_SUCCESS = 'DELETE_SMS_MANAGEMENT_SUCCESS';
export const DELETE_SMS_MANAGEMENT_FAILURE = 'DELETE_SMS_MANAGEMENT_FAILURE';

export const fetchSmsManagementRequest = (params = {}) => ({
    type: FETCH_SMS_MANAGEMENT_REQUEST,
    payload: params,
});

export const fetchSmsManagementSuccess = (data) => ({
    type: FETCH_SMS_MANAGEMENT_SUCCESS,
    payload: data,
});

export const fetchSmsManagementFailure = (error) => ({
    type: FETCH_SMS_MANAGEMENT_FAILURE,
    payload: error,
});

export const fetchSmsManagementByIdRequest = (smsManagementId) => ({
    type: FETCH_SMS_MANAGEMENT_BY_ID_REQUEST,
    payload: smsManagementId,
});

export const fetchSmsManagementByIdSuccess = (data) => ({
    type: FETCH_SMS_MANAGEMENT_BY_ID_SUCCESS,
    payload: data,
});

export const fetchSmsManagementByIdFailure = (error) => ({
    type: FETCH_SMS_MANAGEMENT_BY_ID_FAILURE,
    payload: error,
});

export const createSmsManagementRequest = (partnerId, smsManagementData) => ({
    type: CREATE_SMS_MANAGEMENT_REQUEST,
    payload: { partnerId, smsManagementData },
});

export const createSmsManagementSuccess = (data) => ({
    type: CREATE_SMS_MANAGEMENT_SUCCESS,
    payload: data,
});

export const createSmsManagementFailure = (error) => ({
    type: CREATE_SMS_MANAGEMENT_FAILURE,
    payload: error,
});

export const updateSmsManagementRequest = (smsManagementId, smsManagementData) => ({
    type: UPDATE_SMS_MANAGEMENT_REQUEST,
    payload: { smsManagementId, smsManagementData },
});

export const updateSmsManagementSuccess = (data) => ({
    type: UPDATE_SMS_MANAGEMENT_SUCCESS,
    payload: data,
});

export const updateSmsManagementFailure = (error) => ({
    type: UPDATE_SMS_MANAGEMENT_FAILURE,
    payload: error,
});

export const deleteSmsManagementRequest = (smsManagementId) => ({
    type: DELETE_SMS_MANAGEMENT_REQUEST,
    payload: smsManagementId,
});

export const deleteSmsManagementSuccess = () => ({
    type: DELETE_SMS_MANAGEMENT_SUCCESS,
});

export const deleteSmsManagementFailure = (error) => ({
    type: DELETE_SMS_MANAGEMENT_FAILURE,
    payload: error,
});
